import { render, staticRenderFns } from "./applyWithdraw.vue?vue&type=template&id=6ff420a8&scoped=true"
import script from "./applyWithdraw.vue?vue&type=script&lang=js"
export * from "./applyWithdraw.vue?vue&type=script&lang=js"
import style0 from "./applyWithdraw.vue?vue&type=style&index=0&id=6ff420a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff420a8",
  null
  
)

export default component.exports